import api, { methods } from "@api";
import Spacer from "@components/Spacer";
import Button from "@components/button";
import HeaderDetail from "@components/header-detail";
import Link from "@components/link";
import TextInput from "@components/text-input";
import AuthImage from "@features/auth/auth-image";
import Error from "@features/error/error";
import ScreenScrollView from "@features/scroll-view/screen-scroll-view";
import { useAuth } from "@provider/context-auth";
import { useMutation } from "@tanstack/react-query";
import { looksLikeMail, useOrientation } from "@utils";
import { Container, View } from "dripsy";
import * as React from "react";
import { Platform } from "react-native";
import { useNavigation } from "react-native-ridge-navigation";
import { Form, useFormState } from "react-native-use-form";

import routes from "../../NavigatorRoutes";

function LoginScreen() {
  const orientation = useOrientation();

  return (
    <View
      sx={{
        backgroundColor: "$secondaryBackground",
        flex: 1,
        height: "100%",
      }}
    >
      <ScreenScrollView avoidKeyboard>
        {Platform.OS !== "web" ? <HeaderDetail hasImage withBottomBorder={false} /> : null}
        <Container variant="small" sx={{ opacity: 0.9 }}>
          {Platform.OS === "web" ? (
            <>
              <Spacer size="$6" />
              <Spacer size="$6" />
            </>
          ) : (
            <Spacer />
          )}
          <Login />
        </Container>
      </ScreenScrollView>
      {orientation === "PORTRAIT" ? <AuthImage /> : null}
    </View>
  );
}

export function Login() {
  const { popToTop } = useNavigation();
  const { login, isLoading: isLoadingAuth, isLoadingError, isAuthenticated } = useAuth();

  React.useEffect(() => {
    if (isAuthenticated) {
      popToTop();
    }
  }, [isAuthenticated]);
  const { mutate, isPending, isError, error, reset } = useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      api<{ authenticated: boolean; token: string }>({
        path: "/login",
        method: methods.POST,
        body: { email, password },
      }),
    onSuccess: (res) => {
      login(res.token);
    },
  });

  const [form, inputs] = useFormState(
    process.env.NODE_ENV === "development"
      ? {
          email: "arjen.de.vos@webridge.nl",
          password: "Test123",
        }
      : { email: "", password: "" },
    {
      onChange: (latestValues) => {
        // do something with latestValues
      },
      onSubmit: async ({ email, password }) => {
        mutate({ email, password });
      },
    }
  );
  return (
    <>
      <Form {...form.formProps}>
        <TextInput
          color="$secondaryBackground"
          {...inputs.email("email", {
            required: true,
            label: "E-mailadres",
            onChangeText: (v) => reset(),
            validate: (v) => {
              return looksLikeMail(v) ? true : "E-mailadres moet @ en . bevatten";
            },
          })}
          testID="login-email"
        />
        {/*<Error isError={form.hasError("email")} error={form.errors.email} paddingBottom="$2" />*/}

        <TextInput
          color="$secondaryBackground"
          {...inputs.password("password", {
            onChangeText: (v) => reset(),
            required: true,
            label: "Wachtwoord",
          })}
          onSubmitEditing={form.submit}
        />
        <Button testID="login-submit" onPress={form.submit} isLoading={isLoadingAuth || isPending}>
          Inloggen
        </Button>
      </Form>
      <Error isError={isLoadingError} error="Fout bij ophalen profiel" paddingBottom="$2" paddingTop="$2" />

      <Error isError={isError} error={(error as any)?.message} paddingBottom="$2" paddingTop="$2" />
      <Spacer size="$1" />

      <View
        sx={{
          alignItems: "center",
        }}
      >
        <Link to={routes.PasswordResetRequestScreen} params={{}} title="Wachtwoord vergeten" />
      </View>
    </>
  );
}
export default LoginScreen;
